import { NgClass } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';

import { ToastService } from '@core/services/toast.service';

@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [NgClass, NgbToast],
  templateUrl: './toast-host.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast-host.component.css'
})
export class ToastHostComponent {
  protected readonly toast = inject(ToastService);

  ngClassFor(type: 'success' | 'error' | 'warning' | 'info'): Record<string, boolean> {
    return {
      'align-items-center': true,
      'text-white': type === 'success' || type === 'error',
      'text-dark': type === 'warning',
      'border-0': true,
      'bg-success': type === 'success',
      'bg-danger': type === 'error',
      'bg-warning': type === 'warning',
      'bg-info': type === 'info'
    };
  }

  isWarning(type: 'success' | 'error' | 'warning' | 'info'): boolean {
    return type === 'warning';
  }
}
